import { setComponentMapOverrides } from '@jutro/uiconfig';

import { PaymentDetailsPage, QualificationPage, CommonQuote, CommonPackageDetails } from 'gw-capability-quoteandbind-common-react';

import FARMYourInfoPage from './pages/YourInfo/YourInfoPage';
import FARMQuotePage from './pages/Quote/QuotePage';
import FARMAdditionalInformation from './pages/AdditionalInformation/AdditionalInformationPage';
import FARMPolicyInformationPage from './pages/PolicyInformation/PolicyInformationPage';
import FARMSuccessPage from './pages/Success/SuccessPage';
//import FARMPackageDetailsPage from './pages/PackageDetails/PackageDetailsPage';
import FARMFarmerDetailsPage from './pages/FarmerDetails/FarmerDetailsPage';
//import FARMRiskAnalysisPage from './pages/RiskAnalysis/RiskAnalysisPage'

setComponentMapOverrides(
    {
        FARMYourInfoPage: { component: 'FARMYourInfoPage' },
       // FARMQualificationPage: { component: 'FARMQualificationPage' },
        FARMPackageDetailsPage: { component: 'FARMPackageDetailsPage' },
        FARMFarmerDetailsPage: { component: 'FARMFarmerDetailsPage' },
        //FARMRiskAnalysisPage: { component: 'FARMRiskAnalysisPage' },
        FARMQuotePage: { component: 'FARMQuotePage' },
        FARMAdditionalInformation: { component: 'FARMAdditionalInformation' },
        FARMPolicyInformationPage: { component: 'FARMPolicyInformationPage' },
        FARMPaymentDetailsPage: { component: 'FARMPaymentDetailsPage' },
        FARMSuccessPage: { component: 'FARMSuccessPage' }
    },
    {
        FARMYourInfoPage,
       // FARMQualificationPage: QualificationPage,
        FARMPackageDetailsPage: CommonPackageDetails,
        FARMFarmerDetailsPage,
        //FARMRiskAnalysisPage,
        //FARMQuotePage: CommonQuote,
        FARMQuotePage,
        FARMAdditionalInformation,
        FARMPolicyInformationPage,
        FARMPaymentDetailsPage: PaymentDetailsPage,
        FARMSuccessPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as FARMWizard } from './FARMWizard';
